import data from '../data/shirts'
import colors from '../data/colors'
import textures from '../data/textures'

const shirts = {
  namespaced: true,
  state: {
    data,
    colors,
    textures,
    selectedArea: {
      id: 1,
      slug: 'overall',
      name: '全体'
    },
    selectedPart: [
      {
        id: 1,
        slug: 'body_main',
        name: '胴',
        area_id: 2,
      },
      {
        id: 3,
        slug: 'arm_shoulder_part',
        name: '肩パーツ',
        area_id: 4,
      },
    ],
    selectedOverallItem: {
      id: 1,
      name: '単色',
      slug: 'single_color'
    },
    selectedOverallItemSingleColor: null,
    selectedOverallItemGradationStartColor: null,
    selectedOverallItemGradationEndColor: null,
    selectedOverallItemStripeColor: null,
    selectedOverallItemTexture: null,
    selectedBodyMainItem: {},
    selectedBodyMainItemColor: null,
    selectedBodyMainItemTexture: null,
    selectedBodySideItem: {},
    selectedBodySideItemColor: null,
    selectedBodySideItemColor2: null,
    selectedBodySideItemTexture: null,
    selectedCollarItem: {},
    selectedCollarItemColor: null,
    selectedCollarItemColor2: null,
    selectedCollarItemColor3: null,
    selectedArmShoulderPartItem: {},
    selectedArmShoulderPartItemColor: null,
    selectedArmArmPartItem: {},
    selectedArmArmPartItemColor: null,
    selectedArmArmPartItemColor2: null,
    selectedArmSleevePartItem: {},
    selectedArmSleevePartItemColor: null,
    selectedArmSleevePartItemColor2: null,
    selectedArmSleeveLineItem: {},
    selectedArmSleeveLineItemColor: null,
    selectedArmSleeveLineItemColor2: null,
    selectedArmSleeveLineItemColor3: null,
  },
  mutations: {
    // 選択状態の初期化
    clearShirts (state) {
      state.selectedArea = {
        id: 1,
        slug: 'overall',
        name: '全体'
      }
      state.selectedPart = [
        {
          id: 1,
          slug: 'body_main',
          name: '胴',
          area_id: 2,
        },
        {
          id: 4,
          slug: 'arm_shoulder_part',
          name: '肩パーツ',
          area_id: 4,
        },
      ]
      state.selectedOverallItem = {
        id: 1,
        name: '単色',
        slug: 'single_color'
      }
      state.selectedOverallItemSingleColor = null
      state.selectedOverallItemGradationStartColor = null
      state.selectedOverallItemGradationEndColor = null
      state.selectedOverallItemStripeColor = null
      state.selectedOverallItemTexture = null
      state.selectedBodyMainItem = {}
      state.selectedBodyMainItemColor = null
      state.selectedBodyMainItemTexture = null
      state.selectedBodySideItem = {}
      state.selectedBodySideItemColor = null
      state.selectedBodySideItemColor2 = null
      state.selectedBodySideItemTexture = null
      state.selectedCollarItem = {}
      state.selectedCollarItemColor = null
      state.selectedCollarItemColor2 = null
      state.selectedCollarItemColor3 = null
      state.selectedArmShoulderPartItem = {}
      state.selectedArmShoulderPartItemColor = null
      state.selectedArmArmPartItem = {}
      state.selectedArmArmPartItemColor = null
      state.selectedArmArmPartItemColor2 = null
      state.selectedArmSleevePartItem = {}
      state.selectedArmSleevePartItemColor = null
      state.selectedArmSleevePartItemColor2 = null
      state.selectedArmSleeveLineItem = {}
      state.selectedArmSleeveLineItemColor = null
      state.selectedArmSleeveLineItemColor2 = null
      state.selectedArmSleeveLineItemColor3 = null
    },
    // エリアの選択
    changeArea (state, payload) {
      state.selectedArea = payload
    },
    // パーツの変更
    changePart (state, payload) {
      const addPart = state.selectedPart.concat()
      addPart.unshift(payload);
      state.selectedPart = addPart.filter((item, index, self) => {
        return self.findIndex(i => i.area_id === item.area_id) === index
      })
    },
    // 全体アイテムの選択
    changeOverallItem (state, payload) {
      state.selectedOverallItem = payload;
    },
    // 全体アイテム 単色の色選択
    changeOverallItemSingleColor (state, payload) {
      state.selectedOverallItemSingleColor = payload;
    },
    // 全体アイテム グラデーションの開始色選択
    changeOverallItemGradationStartColor (state, payload) {
      state.selectedOverallItemGradationStartColor = payload;
    },
    // 全体アイテム グラデーションの終了色選択
    changeOverallItemGradationEndColor (state, payload) {
      state.selectedOverallItemGradationEndColor = payload;
    },
    // 全体アイテム ストライプ色選択
    changeOverallItemStripeColor (state, payload) {
      state.selectedOverallItemStripeColor = payload;
    },
    // 全体アイテム テクスチャの選択
    changeOverallItemTexture (state, payload) {
      state.selectedOverallItemTexture = payload;
    },
    // 胴： 胴アイテムの選択
    changeBodyMainItem (state, payload) {
      state.selectedBodyMainItem = payload
    },
    // 胴： 胴アイテム 色の選択
    changeBodyMainItemColor (state, payload) {
      state.selectedBodyMainItemColor = payload
    },
    // 胴： 胴アイテム テクスチャの選択
    changeBodyMainItemTexture (state, payload) {
      state.selectedBodyMainItemTexture = payload
    },
    // 胴： 脇アイテムの選択
    changeBodySideItem (state, payload) {
      state.selectedBodySideItem = payload
    },
    // 胴： 脇アイテム 色の選択
    changeBodySideItemColor (state, payload) {
      state.selectedBodySideItemColor = payload
    },
    changeBodySideItemColor2 (state, payload) {
      state.selectedBodySideItemColor2 = payload
    },
    // 胴： 脇アイテム テクスチャの選択
    changeBodySideItemTexture (state, payload) {
      state.selectedBodySideItemTexture = payload
    },
    // 襟ライン アイテムの選択
    changeCollarItem(state, payload) {
      state.selectedCollarItem = payload
    },
    // 襟ライン アイテム 色の選択
    changeCollarItemColor (state, payload) {
      state.selectedCollarItemColor = payload
    },
    changeCollarItemColor2 (state, payload) {
      state.selectedCollarItemColor2 = payload
    },
    changeCollarItemColor3 (state, payload) {
      state.selectedCollarItemColor3 = payload
    },
    // 腕： 肩パーツアイテムの選択
    changeArmShoulderPartItem (state, payload) {
      state.selectedArmShoulderPartItem = payload
    },
    // 腕： 肩パーツアイテム 色の選択
    changeArmShoulderPartItemColor (state, payload) {
      state.selectedArmShoulderPartItemColor = payload
    },
    // 腕： 腕パーツアイテムの選択
    changeArmArmPartItem (state, payload) {
      state.selectedArmArmPartItem = payload
    },
    // 腕： 腕パーツアイテム 色の選択
    changeArmArmPartItemColor (state, payload) {
      state.selectedArmArmPartItemColor = payload
    },
    changeArmArmPartItemColor2 (state, payload) {
      state.selectedArmArmPartItemColor2 = payload
    },
    // 腕： 袖パーツアイテムの選択
    changeArmSleevePartItem (state, payload) {
      state.selectedArmSleevePartItem = payload
    },
    // 腕： 袖パーツアイテム 色の選択
    changeArmSleevePartItemColor (state, payload) {
      state.selectedArmSleevePartItemColor = payload
    },
    changeArmSleevePartItemColor2 (state, payload) {
      state.selectedArmSleevePartItemColor2 = payload
    },
    // 腕： 袖ラインアイテムの選択
    changeArmSleeveLineItem (state, payload) {
      state.selectedArmSleeveLineItem = payload
    },
    // 腕： 袖ラインアイテム 色の選択
    changeArmSleeveLineItemColor (state, payload) {
      state.selectedArmSleeveLineItemColor = payload
    },
    changeArmSleeveLineItemColor2 (state, payload) {
      state.selectedArmSleeveLineItemColor2 = payload
    },
    changeArmSleeveLineItemColor3 (state, payload) {
      state.selectedArmSleeveLineItemColor3 = payload
    },
  }
}
export default shirts